var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m68.102 82.199c0 1.6016-1.3008 2.8008-2.8008 2.8008s-2.8008-1.3008-2.8008-2.8008v-52.5h-9.6992v52.5c0 1.6016-1.3008 2.8008-2.8008 2.8008s-2.8008-1.3008-2.8008-2.8008v-52.5h-9.6016v52.5c0 1.6016-1.3008 2.8008-2.8008 2.8008s-2.8008-1.3008-2.8008-2.8008l0.003906-52.5h-13.102v55.602c0 6.6992 5.5 12.199 12.199 12.199h37.801c6.6992 0 12.199-5.5 12.199-12.199l0.003906-55.602h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87 15.898h-20.102v-9.1992c0-2.3008-1.8984-4.1992-4.1992-4.1992h-25.398c-2.3008 0-4.1992 1.8984-4.1992 4.1992v9.1992h-20.102c-2.3008 0-4.1992 1.8984-4.1992 4.1992 0 2.3008 1.8984 4.1992 4.1992 4.1992h74c2.3008 0 4.1992-1.8984 4.1992-4.1992 0-2.2969-1.8008-4.1992-4.1992-4.1992zm-45.5-4.8984h16.898v5h-16.898z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.616b789db5b18e70d931ff41edf4c28f.svg";
export { ForwardRef as ReactComponent };